export default __webpack_public_path__ + "static/media/instagram.fdd8b7e9.svg";